import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CalendarImg from "../../assets/images/calendarIcon.svg";
import medicineImg from "../../assets/images/biry.jpg";
import ApiConfig from "../../api/ApiConfig";
import { simpleGetCallWithErrorResponse } from "../../api/ApiServices";


const MyOrders = () => {
  const [orderData, setOrderData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadDataSocket();
  }, []);

  const loadDataSocket = async () => {
    try {
      const response = await simpleGetCallWithErrorResponse(
        `${ApiConfig.ORDER_LIST}?page=1&page_size=9999`
      );
      console.log("response =>", response);

      if (response.json?.data?.length > 0) {
        setOrderData(response.json.data);
      } else {
        setOrderData([]);
      }
    } catch (error) {
      console.error("Error loading orders:", error);
    } finally {
      setIsLoading(false);
    }
  };
 const StatusTypeVT = (val) => {
  switch (String(val)) { // convert to string
    case '0': return 'Order Received';
    case '1': return 'Delivery Person Assigned';
    case '2': return 'Order Dispatched';
    case '3': return 'Ready to Delivery';
    case '4': return 'Payment Done';
    case '5': return 'Order Delivered';
    case '6': return 'Returned';
    case '7': return 'Return Back to Warehouse';
    case '8': return 'Delivery Person Reached For Pickup';
    case '9': return 'Delivery Person Reached For Delivery';
    case '10': return 'Cancelled';
    case '11': return 'Pending Refund';
    case '12': return 'Failed Refund';
    case '13': return 'Processed Refund';
    case '14': return 'Order Accepted';
    case '15': return 'Order is being prepared';
    default: return '-';
  }
};

  return (
    <div className="mainOrderSection">
      <div className="row">
        <div className="col-md-12">
          <div className="headingSearch">
            <h1 className="headTxt">My Orders</h1>
            {/* <div className="calendarFiled">
              <input
                type="text"
                className="form-control"
                placeholder="Search Orders"
              />
              <img src={CalendarImg} alt="Calendar" />
            </div> */}
          </div>
        </div>

        {isLoading ? (
          <div className="col-md-12 text-center">
            <p>Loading your orders...</p>
          </div>
        ) : orderData.length === 0 ? (
          <div className="col-md-12 text-center">
            <p>No orders found.</p>
          </div>
        ) : (
          orderData.map((order, index) => (
            <div className="col-md-12" key={index}>
              <div className="completeOrderTracker">
                <div className="dateBorder">
                  <label className="DateLab">Order ID: #{order.order_id}</label>
                  <label className="BorderLine"></label>
                </div>

                <div className="orderDetails">
                  <div className="headFlex">
                    <div className="mediFlex">
                      <div className="mediBox">
                        {/* <img src={medicineImg} alt="Order item" height="40px" /> */}
                      </div>
                      <div className="detailBox">
                        <h6>{order?.order_items?.[0]?.order_item_name}</h6>
                        <label>Payment: {order.payment_type}</label>
                      </div>
                    </div>

                    <div className="keyValueFlex">
                      <label className="key">Amount</label>
                      <label className="kevalue">₹{order.total}</label>
                    </div>

                    {/* <div className="keyValueFlex">
                      <label className="key">Prep Time</label>
                      <label className="kevalue">
                        {order.min_prep_time} min
                      </label>
                    </div> */}

                    <div className="keyValueFlex">
                      <label className="key">Status</label>
                      <label className="kevalue">
                        {StatusTypeVT(order.order_status)}
                      </label>
                    </div>
                  </div>

                  <div className="bottomBtns">
                    <Link to={`/MyOrderDetails/${order.order_id}`}>
                      <button className="locationBtn">View Details</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default MyOrders;
